const CupStatus = {
	UNTOUCHED: 0,
	HIT: 1,
	PENDING: 2,
}

export default CupStatus



// WEBPACK FOOTER //
// ./src/common/CupStatus.js